import { ENUM__float_point_precision } from '@shared/dto/+model/sd/_enums/ENUM__float_point_precision';

export const EPageDiffusionModelsFilterFloatPrecision = {
  ALL: 'ALL',
  ...ENUM__float_point_precision,
};
